import { ProductWithBusinessToList } from '@/entities/businessProduct';
import { BusinessProductService } from '@/services/BusinessProductService';
import { BusinessService } from '@/services/BusinessService';
import React, { useEffect } from 'react';
import { createContext, useState } from 'react';
import { useParams } from 'react-router-dom';

interface ProductWithBusinessContextType{
  openEdit: boolean,
  product2Edit: ProductWithBusinessToList,
  selectedProducts: ProductWithBusinessToList[],
  deleteOpen:boolean
}

const ProductWithBusinessContext = createContext<any>({} as ProductWithBusinessContextType);

export const ProductWithBusinessProvider: React.FC<any> = ({ children }) => {
  // const leadId =  Number(useParams().leadId);
  const [openEdit, setOpenEdit ] = useState(false);
  const [product2Edit, setProduct2Edit] = useState<ProductWithBusinessToList>();
  const [selectedProducts, setSelectedProducts] = useState<ProductWithBusinessToList[] | []>([]);
  const [deleteOpen, setDeleteOpen] = useState(false);

  return(
    <ProductWithBusinessContext.Provider value={{openEdit, product2Edit, selectedProducts, deleteOpen, setDeleteOpen, setSelectedProducts, setProduct2Edit, setOpenEdit}}>{children}</ProductWithBusinessContext.Provider>
  );
};

export const useProductWithBusinessContext = () => React.useContext(ProductWithBusinessContext);
